import { render } from "./BoardReadInfoModal.vue?vue&type=template&id=38bac6ee&scoped=true"
import script from "./BoardReadInfoModal.vue?vue&type=script&lang=js"
export * from "./BoardReadInfoModal.vue?vue&type=script&lang=js"

import "./BoardReadInfoModal.vue?vue&type=style&index=0&id=38bac6ee&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-38bac6ee"

export default script